import { Entity, Fields, Relations, Allow } from "remult";
import { Member } from "../member/entity";

@Entity("chat-entry", {
    allowApiRead: Allow.authenticated,
    allowApiCrud: false
})
export class ChatEntry {
    @Fields.string()
    id = "";

    @Fields.string({ dbName: "chat_id" })
    chatId = "";

    @Fields.string({ dbName: "sender_member_id" })
    senderMemberId?: string;

    @Relations.toOne(() => Member, "senderMemberId")
    sender?: Member;

    @Fields.string()
    text = "";

    @Fields.createdAt({ dbName: "created_at" })
    createdAt = new Date();
}
